import { render } from "./ApiToken.vue?vue&type=template&id=4d868dfe"
import script from "./ApiToken.vue?vue&type=script&lang=js"
export * from "./ApiToken.vue?vue&type=script&lang=js"

import "./ApiToken.vue?vue&type=style&index=0&id=4d868dfe&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__